const rankingItems = [
  { rank: 1, title: '暑期档动作巨制合集', type: '电影专题', hot: '9.8', trend: 'up', tag: '热播中' },
  { rank: 2, title: '高分悬疑烧脑精选', type: '电影专题', hot: '9.6', trend: 'up', tag: '热播中' },
  { rank: 3, title: '经典爱情文艺片回顾', type: '经典重温', hot: '9.4', trend: 'stable', tag: '推荐' },
  { rank: 4, title: '国产高分剧集速递', type: '电视剧', hot: '9.2', trend: 'up', tag: '更新中' },
  { rank: 5, title: '科幻奇幻史诗巨制', type: '电影大全', hot: '9.0', trend: 'stable', tag: '热门' },
  { rank: 6, title: '深夜恐怖片专场', type: '夜猫精选', hot: '8.8', trend: 'up', tag: '午夜场' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          热播排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          本周最受欢迎的高清电影与免费剧集热播榜单
        </p>

        <div className="space-y-3">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-100/70 border border-background-200/60 rounded-xl transition-all duration-200 hover:-translate-y-0.5 hover:border-primary-200/50 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-heading font-bold text-lg ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-400/80 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-400/80 text-background-50'
                  : 'bg-background-200/80 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.type}</span>
                  <span className="text-xs text-foreground-300">|</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    热度 {item.hot}
                  </span>
                  <span className="text-xs text-foreground-300">|</span>
                  <span className="flex items-center gap-1 text-xs whitespace-nowrap">
                    {item.trend === 'up' ? (
                      <>
                        <i className="ri-arrow-up-line text-accent-500"></i>
                        <span className="text-accent-500">上升</span>
                      </>
                    ) : (
                      <>
                        <i className="ri-subtract-line text-foreground-400"></i>
                        <span className="text-foreground-400">稳定</span>
                      </>
                    )}
                  </span>
                </div>
              </div>

              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                <i className="ri-play-circle-line text-primary-500 text-2xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}